define(["exports", "react", "react-intl-universal", "styled-components", "../../atoms"], function (_exports, _react, _reactIntlUniversal, _styledComponents, _atoms) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var ShowHeader = (0, _styledComponents.keyframes)(["from{opacity:0;top:-20px;transform:translate3d(0,0,0);}to{opacity:1;top:49px;transform:translate3d(0,0,0);}"]);

  var ProfessionalHeader = _styledComponents.default.div.withConfig({
    displayName: "HeaderScroll__ProfessionalHeader",
    componentId: "sc-1liqkkn-0"
  })(["background-color:", ";box-shadow:0 1px 2px 0 rgba(0,0,0,0.2);opacity:0;padding:16px 24px;position:absolute;top:49px;visibility:hidden;width:100%;z-index:1;@media print{display:none;}> div:first-of-type{margin:0 16px 0 0;}", " p{margin:0;}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var animateHeader = _ref2.animateHeader;
    return animateHeader && (0, _styledComponents.css)(["animation:", " 0.5s ", " both;display:flex;visibility:visible;"], ShowHeader, function (_ref3) {
      var theme = _ref3.theme;
      return theme.easing.easing;
    });
  });

  var ProfessionalName = (0, _styledComponents.default)(_atoms.P).withConfig({
    displayName: "HeaderScroll__ProfessionalName",
    componentId: "sc-1liqkkn-1"
  })(["font-weight:", ";span{color:", ";font-size:0.9em;}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.darkGray;
  });

  var HeaderScroll = function HeaderScroll(_ref6) {
    var img = _ref6.img,
        name = _ref6.name,
        age = _ref6.age,
        showHeader = _ref6.showHeader;
    return /*#__PURE__*/_react.default.createElement(ProfessionalHeader, {
      animateHeader: showHeader
    }, /*#__PURE__*/_react.default.createElement(_atoms.Avatar, {
      src: img,
      kind: "image",
      size: "sm",
      name: name
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: name
    }, /*#__PURE__*/_react.default.createElement(ProfessionalName, null, name, /*#__PURE__*/_react.default.createElement("span", null, ",", ' ', _reactIntlUniversal.default.get('CURRICULUM.HEADER_PROFISSIONAL.IDADE', {
      born: age
    }), ' ')))));
  };

  var _default = HeaderScroll;
  _exports.default = _default;
});